(function () {
  const STORAGE_KEY = 'ozanatolie_cookie_consent_v1';
  const banner = document.getElementById('CookieConsentBanner');
  if (!banner) return;

  function showBanner() {
    banner.hidden = false;
    banner.removeAttribute('hidden');
    banner.setAttribute('aria-hidden', 'false');
  }

  function hideBanner() {
    banner.hidden = true;
    banner.setAttribute('aria-hidden', 'true');
  }

  function applyConsent(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (_) {}
    document.documentElement.dataset.cookieConsent = value;
    hideBanner();
  }

  banner.querySelector('[data-cookie-accept]')?.addEventListener('click', function () {
    applyConsent('all');
  });

  banner.querySelector('[data-cookie-essential]')?.addEventListener('click', function () {
    applyConsent('essential');
  });

  document.querySelectorAll('[data-cookie-settings-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (_) {}
      delete document.documentElement.dataset.cookieConsent;
      showBanner();
    });
  });

  let stored = null;
  try {
    stored = localStorage.getItem(STORAGE_KEY);
  } catch (_) {}

  if (stored === 'all' || stored === 'essential') {
    document.documentElement.dataset.cookieConsent = stored;
    hideBanner();
    return;
  }

  showBanner();
})();
